import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AssetUIModel } from '@thehubz/client/core';

@Component({
  selector: 'thehubz-westlotto-metadata',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './westlotto-metadata.component.html',
  styleUrls: ['./westlotto-metadata.component.scss'],
})
export class WestlottoMetadataComponent {
  @Input() asset!: AssetUIModel;
}
